module.exports = __webpack_public_path__ + "4c1a2a87db60bdcf8a1baa045f7d3168.pdf";